import { useFormikContext } from 'formik';
import { useId, type ComponentProps } from 'react';

import { ReactSelectTimezones } from 'hb-react/shared/components/ReactSelect';

export const TimezoneSelect = ({
  name,
  label,
  ...props
}: { name: string; label: string } & ComponentProps<
  typeof ReactSelectTimezones
>) => {
  const { values, setFieldValue } = useFormikContext<{
    [key: string]: number[];
  }>();
  const id = useId();

  return (
    <ReactSelectTimezones
      id={id}
      required
      name={name}
      label={label}
      onChange={(value: { tzinfo_name: string; id: string; name: string }) => {
        setFieldValue(name, value.tzinfo_name);
      }}
      value={values[name]}
      {...props}
    />
  );
};
